const _excluded = ["className", "children"],
      _excluded2 = ["className", "children"],
      _excluded3 = ["className", "children"],
      _excluded4 = ["className", "children"],
      _excluded5 = ["as", "children", "before", "after", "className", "tooltip", "intent", "disabled", "data-testid"],
      _excluded6 = ["id", "as", "children", "before", "className", "items", "collapsed", "onClick"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cn from 'classnames';
import styles from "./Sidebar.module.scss";
import { WideArrowDownward, WideArrowUpward } from "../../icons";
import { Tooltip } from "../Tooltip";
import { useIntentBehavior } from "../IntentBehavior";

function Sidebar(props) {
  const {
    className,
    children
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cn(styles.root, className)
  }), children);
}

Sidebar.Header = SidebarHeader;
Sidebar.Content = SidebarContent;
Sidebar.Footer = SidebarFooter;
Sidebar.Item = SidebarItem;
Sidebar.Group = SidebarGroup;
/** Add this class to the SidebarItem to give it an active look. */

const SIDEBAR_ITEM_ACTIVE_CLASS = styles.active;

function SidebarHeader(props) {
  const {
    className,
    children
  } = props,
        rest = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cn(styles.header, className)
  }), children);
}

function SidebarContent(props) {
  const {
    className,
    children
  } = props,
        rest = _objectWithoutProperties(props, _excluded3);

  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cn(styles.content, className)
  }), children);
}

function SidebarFooter(props) {
  const {
    className,
    children
  } = props,
        rest = _objectWithoutProperties(props, _excluded4);

  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cn(styles.footer, className)
  }), children);
}

function SidebarItem(props) {
  const {
    as,
    children,
    before,
    after,
    className,
    tooltip,
    intent,
    disabled,
    ['data-testid']: testid
  } = props,
        rest = _objectWithoutProperties(props, _excluded5);

  const {
    getDisabled,
    getTooltip
  } = useIntentBehavior();
  const disabledFromIntent = intent ? getDisabled(intent) : false;
  const tooltipFromIntent = intent ? getTooltip(intent) : null;
  const hasTooltip = !!(tooltip !== null && tooltip !== void 0 && tooltip.title) || !!tooltipFromIntent;
  const RootElement = as || 'button';
  const item = /*#__PURE__*/React.createElement(RootElement, _extends({}, rest, {
    disabled: disabledFromIntent || disabled,
    className: cn(styles.item, className),
    "data-testid": testid
  }), before && /*#__PURE__*/React.createElement("span", {
    className: styles.itemPrefix
  }, before), children && /*#__PURE__*/React.createElement("span", {
    className: styles.itemContent
  }, children), after && /*#__PURE__*/React.createElement("span", {
    className: styles.itemSuffix,
    "data-testid": testid && testid + '-suffix'
  }, after));
  return hasTooltip ? /*#__PURE__*/React.createElement(Tooltip, _extends({
    placement: "top"
  }, tooltip || {
    title: tooltipFromIntent
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.wrapper, className),
    "data-testid": testid && "".concat(testid, "-wrapper")
  }, item)) : item;
}

function SidebarGroup(props) {
  const {
    id,
    as,
    children,
    before,
    className,
    items,
    collapsed,
    onClick
  } = props,
        rest = _objectWithoutProperties(props, _excluded6);

  const RootElement = as || 'button';
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.group, collapsed ? styles.collapsed : '')
  }, /*#__PURE__*/React.createElement(RootElement, _extends({}, rest, {
    id: id,
    className: cn(styles.groupToggle, className),
    onClick: onClick
  }), before && /*#__PURE__*/React.createElement("span", {
    className: styles.itemPrefix
  }, before), children && /*#__PURE__*/React.createElement("span", {
    className: styles.itemContent
  }, children), /*#__PURE__*/React.createElement("span", {
    className: styles.itemSuffix,
    "data-testid": props['data-testid'] && props['data-testid'] + '-suffix'
  }, collapsed ? /*#__PURE__*/React.createElement(WideArrowDownward, {
    width: 18,
    height: 18
  }) : /*#__PURE__*/React.createElement(WideArrowUpward, {
    width: 18,
    height: 18
  }))), items);
}

export { Sidebar, SidebarHeader, SidebarContent, SidebarFooter, SidebarItem, SidebarGroup, SIDEBAR_ITEM_ACTIVE_CLASS };